import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { dispatchEvent } from 'fg-frontend/src/lib/dom';

const fragments = {
  ITEM: '[data-fragment="AccordionComponent.item"]',
  LINK: '[data-fragment="AccordionComponent.link"]',
  OPEN_ALL: '[data-fragment="AccordionComponent.openAll"]',
  CLOSE_ALL: '[data-fragment="AccordionComponent.closeAll"]',
  TOGGLE_ALL: '[data-fragment="AccordionComponent.toggleAll"]',
  OPEN_BY_ID: '[data-fragment="AccordionComponent.openById"]',
  CLOSE_BY_ID: '[data-fragment="AccordionComponent.closeById"]',
  TOGGLE_BY_ID: '[data-fragment="AccordionComponent.toggleById"]',
};

class AccordionComponent extends WebComponent {
  constructor(props) {
    super(props);
    const {
      show = true,
      lastItem = null,
      expandedAllItems = false,
    } = props;
    this.state = {
      show,
      lastItem,
      expandedAllItems,
    };
  }

  didMount() {
    const {
      activeClass,
      contentClass,
      showOnlyOneItem,
      anchorScrollToItem,
      anchorOpenItem,
      itemTopOffset,
      debugEnabled,
    } = this.props;

    this.activeClass = activeClass;
    this.contentClass = contentClass;
    this.showOnlyOneItem = showOnlyOneItem;
    this.anchorScrollToItem = anchorScrollToItem;
    this.anchorOpenItem = anchorOpenItem;
    this.itemTopOffset = itemTopOffset;
    this.debugEnabled = debugEnabled;

    this.on('click', fragments.LINK, this.handleClickOnLink);
    this.on('click', fragments.OPEN_ALL, this.openAllItems);
    this.on('click', fragments.CLOSE_ALL, this.closeAllItems);
    this.on('click', fragments.TOGGLE_ALL, this.toggleAllItems);
    this.on('click', fragments.OPEN_BY_ID, this.openItemById);
    this.on('click', fragments.CLOSE_BY_ID, this.closeItemById);
    this.on('click', fragments.TOGGLE_BY_ID, this.toggleItemById);

    this.itemElement = this.element.querySelectorAll(fragments.ITEM);

    const hashId = window.location.hash.substr(1);
    if (hashId !== '') {
      this.itemElementHash = this.element.querySelector('#' + hashId);
      if (this.itemElementHash) {
        if (this.anchorOpenItem) {
          dispatchEvent(this.itemElementHash.querySelector('[data-fragment="AccordionComponent.link"]'), 'click');
        }
        if (this.anchorScrollToItem) {
          const _self = this;
          setTimeout(function () {
            _self.scrollToElement(_self.itemElementHash.nextElementSibling);
          }, 500);
        }
      }
    }
  }

  handleClickOnLink = (e) => {
    const {
      show,
      lastItem,
    } = this.state;

    e.preventDefault();
    e.stopPropagation();

    this.setState({
      lastItem,
    });
    const _self = this;

    const parentElId = e.target.dataset.id;
    const parentEl = this.element.querySelector('#'+parentElId);
    if (this.showOnlyOneItem) {
      if (lastItem && lastItem !== parentEl) {
        this.closeItem(lastItem);
      }
    }

    if (show && !parentEl.classList.contains(this.activeClass)) {
      setTimeout(function () {
        _self.openItem(parentEl);
      }, 200);
    } else {
      this.closeItem(parentEl);
    }
  };

  openItem = (el) => {
    el.classList.add(this.activeClass);
    el.setAttribute('aria-expanded', 'true');
    this.setState({ lastItem: el });
    const elContent = el.nextElementSibling.querySelector('.' + this.contentClass);
    elContent.classList.add(this.activeClass);
    if (elContent.scrollHeight > 9999) {
      elContent.style.maxHeight = elContent.scrollHeight + 'px';
    }
  };

  closeItem = (el) => {
    el.classList.remove(this.activeClass);
    el.setAttribute('aria-expanded', 'false');
    const elContent = el.nextElementSibling.querySelector('.' + this.contentClass);
    elContent.classList.remove(this.activeClass);
    elContent.style.maxHeight = null;
  };

  // openAllItems = () => {
  //   const _self = this;
  //   this.itemElement.forEach(function (item, index) {
  //     _self.openItem(item);
  //   });
  //   this.setState({ expandedAllItems: true });
  // };
  //
  // closeAllItems = () => {
  //   const _self = this;
  //   this.itemElement.forEach(function (item, index) {
  //     _self.closeItem(item);
  //   });
  //   this.setState({ expandedAllItems: false });
  // };
  //
  // toggleAllItems = () => {
  //   const {
  //     expandedAllItems,
  //   } = this.state;
  //   if (expandedAllItems) {
  //     this.closeAllItems();
  //   } else {
  //     this.openAllItems();
  //   }
  //   this.setState({ expandedAllItems: !expandedAllItems });
  // };
  //
  // openItemById = (e) => {
  //   const itemElById = this.isExistsElement(e.target.dataset.id);
  //   if (itemElById) {
  //     this.openItem(itemElById);
  //   }
  // };
  //
  // closeItemById = (e) => {
  //   const itemElById = this.isExistsElement(e.target.dataset.id);
  //   if (itemElById) {
  //     this.closeItem(itemElById);
  //   }
  // };
  //
  // toggleItemById = (e) => {
  //   const itemElById = this.isExistsElement(e.target.dataset.id);
  //   if (itemElById) {
  //     if (itemElById.classList.contains(this.activeClass)) {
  //       this.closeItem(itemElById);
  //     } else {
  //       this.openItem(itemElById);
  //     }
  //   }
  // };
  //
  // isExistsElement = (itemId) => {
  //   let itemElById = false;
  //   if (itemId % 1 === 0) {
  //     itemElById = this.itemElement[itemId];
  //   } else {
  //     if (!itemId.startsWith('#')) {
  //       itemId = '#' + itemId;
  //     }
  //     const itemEl = this.element.querySelector(itemId);
  //     if (itemEl) {
  //       itemElById = itemEl.parentElement;
  //     }
  //   }
  //   if (!itemElById) {
  //
  //     this.log('isExistsElement', 'Element with id ' + itemId + ' not exist');
  //   }
  //   return itemElById;
  // };

  scrollToElement = (el) => {
    const elOffsetTop = el.offsetTop;
    window.scroll({
      top: elOffsetTop - this.itemTopOffset,
      behavior: 'smooth',
    });
  };

  willUnMount() {
    this.elements = null;
  }

  log = (l, msg) => {
    if (typeof (msg) !== 'string') msg = '-';
    if (this.debugEnabled && window.console) {
      console.log('-- Debug Accordion: ' + l + ' : ' + msg + ' :End --');
    }
  };
}

AccordionComponent.defaultProps = {
  activeClass: 'active',
  contentClass: 'accordion__content',
  itemTopOffset: 10,
  showOnlyOneItem: true,
  anchorScrollToItem: true,
  anchorOpenItem: true,
  debugEnabled: false,
};

export default AccordionComponent;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/AccordionComponent.js